<script setup lang="ts">
import { computed } from 'vue'

import { CarOfferWidgetType } from '@xcel-next/core/enums'
import { ImageSrcSetFormat } from '@xcel-next/rendering-tools/types/constants'

import { useImgSrcSet } from '../../../composables/use-img-src-set'

import type { ImageObject } from '../../../composables/use-img-src-set'

const props = defineProps<{
  type: CarOfferWidgetType
  brand?: string
  image?: ImageObject
}>()

const { createImgSrc } = useImgSrcSet()

const imageSrc = computed(() => {
  if (!props.image) return undefined

  return createImgSrc({
    image: props.image,
    brand: props.brand ?? '',
    setName: props.type === CarOfferWidgetType.find ? 'carwowFinder' : 'carwowLeasingAndBuy',
    type: 'webp',
    srcSetDefinition: {
      format: ImageSrcSetFormat.Landscape
    }
  }) ?? undefined
})

const imageAltTextWithCredit = computed(() =>
  `${props.image?.imageAltText} - Foto: ${props.image?.imageCredit}`.replace(/['"]+/g, '')
)
</script>

<template>
  <figure>
    <img :src="imageSrc"
         :alt="imageAltTextWithCredit"
         width="16"
         height="9"
         loading="lazy">
  </figure>
</template>
